import { AfterViewInit, Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router, NavigationStart } from "@angular/router";
import { CommentComponent } from "../comment/comment.component";

@Component({
  selector: "app-access-role-info",
  templateUrl: "./access-role-info.component.html",
  styleUrls: ["./access-role-info.component.scss"],
})
export class AccessRoleInfoComponent implements OnInit, AfterViewInit {
  userData: any;
  userRole: string;
  steps = [
    {
      image: "assets/step1.png",
      title: "Step 1:",
      description:
        "Tap your profile icon at the top right corner of the screen to open your profile page.",
    },
    {
      image: "assets/step2.png",
      title: "Step 2:",
      description: "On your profile page, tap the “Edit Profile” option.",
    },
    {
      image: "assets/step3.png",
      title: "Step 3:",
      description:
        'Under "User Role", select either "Content Creator" or "Business".',
    },
    {
      image: "assets/step4.png",
      title: "Step 4:",
      description:
        'Click "Save". Your new access is applied automatically — no need to log out.',
    },
  ];

  constructor(
    private router: Router,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AccessRoleInfoComponent>
  ) {}

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.userRole =
      this.userData?.userRole == "User"
        ? this.userData?.userType
        : this.userData?.userRole;

    // Close this dialog automatically on any route change
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.dialogRef.close();
      }
    });
  }

  ngAfterViewInit(): void {
    this.userData?.userRole == "User"
      ? this.userData?.userType
      : this.userData?.userRole;
  }

  goToProfile() {
    this.dialogRef.close();
    this.router.navigate(["/user-profile"]); // update as per your routing
  }
  close() {
    this.dialogRef.close();
  }
}
